var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalentsMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employees_2911133",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39820",
    "data-name": "Path 39820",
    d: "M7.9,9.3,7.51,7l.152-.152-.479-.491a2.64,2.64,0,0,1-.631-2.675c.012-.035.023-.058.035-.093L6.435,3.57,5.454,1.5a.879.879,0,0,0-1.588,0L2.9,3.581.736,3.92a.875.875,0,0,0-.689.6.867.867,0,0,0,.21.888L1.845,7.027l-.374,2.3a.884.884,0,0,0,.864,1.016.909.909,0,0,0,.432-.105L4.683,9.164,6.61,10.215a.9.9,0,0,0,.934-.047A.882.882,0,0,0,7.9,9.3Z",
    transform: "translate(0 0.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39821",
    "data-name": "Path 39821",
    d: "M25.087,4.481a.861.861,0,0,0-.7-.584L22.225,3.57,21.244,1.5a.879.879,0,0,0-1.588,0l-.969,2.079-.128.023c0,.012.012.023.012.035a2.6,2.6,0,0,1-.6,2.663l-.526.537.187.187-.374,2.3a.884.884,0,0,0,.864,1.016.909.909,0,0,0,.432-.105l1.915-1.075L22.4,10.215a.9.9,0,0,0,.934-.047.882.882,0,0,0,.35-.864L23.3,7l1.588-1.635a.882.882,0,0,0,.2-.888Z",
    transform: "translate(2.867 0.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39822",
    "data-name": "Path 39822",
    d: "M9.793,11.68a.877.877,0,0,1-.865-1.014l.5-3.154L7.251,5.3a.876.876,0,0,1,.489-1.48l2.967-.463L12.033.507A.875.875,0,0,1,12.823,0h0a.876.876,0,0,1,.792.5l1.345,2.837,2.969.443a.876.876,0,0,1,.5,1.476L16.267,7.489l.526,3.149a.876.876,0,0,1-1.285.912L12.857,10.1l-2.64,1.469a.859.859,0,0,1-.425.111Z",
    transform: "translate(1.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1280",
    "data-name": "Ellipse 1280",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(2.016 14.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39823",
    "data-name": "Path 39823",
    d: "M7.79,18.467A4.894,4.894,0,0,0,5.84,22.38v.292H.876A.882.882,0,0,1,0,21.8v-.584A3.21,3.21,0,0,1,3.212,18h2.92A3.191,3.191,0,0,1,7.79,18.467Z",
    transform: "translate(0 2.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1281",
    "data-name": "Ellipse 1281",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(20.984 14.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39824",
    "data-name": "Path 39824",
    d: "M25.12,21.212V21.8a.882.882,0,0,1-.876.876H19.281V22.38a4.894,4.894,0,0,0-1.951-3.913A3.191,3.191,0,0,1,18.989,18h2.92A3.21,3.21,0,0,1,25.12,21.212Z",
    transform: "translate(2.88 2.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1282",
    "data-name": "Ellipse 1282",
    cx: 3.504,
    cy: 3.504,
    r: 3.504,
    transform: "translate(10.496 13.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39825",
    "data-name": "Path 39825",
    d: "M16.136,19H9.712A3.215,3.215,0,0,0,6.5,22.212v1.752a.876.876,0,0,0,.876.876h11.1a.876.876,0,0,0,.876-.876V22.212A3.215,3.215,0,0,0,16.136,19Z",
    transform: "translate(1.076 3.16)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentsMenuIcon);
export default __webpack_public_path__ + "static/media/talents_menu_icon.9f9ce2c27d5a567ea8a11a29a4d02da2.svg";
export { ForwardRef as ReactComponent };